<template>
    <div class="d-flex main-container">
        <div class="d-flex flex-column align-center color-item">
            <v-avatar
                :size="$vuetify.breakpoint.smAndDown ? '60px' : '100px'"
                :class="{ selected: answerItem.selected }"
                @click="answerItem.selected ? onDeselected() : onSelected()"
                :color="showFallback || !answerItem.imageUrl ? answerItem.color : 'transparent'"
            >
                <v-img :src="answerItem.imageUrl" @error="showFallback = true">
                    <template v-if="showFallback && !answerItem.color" #placeholder>
                        <v-icon color="grey" size="80%">{{ mdiHelp }}</v-icon>
                    </template>
                </v-img>
            </v-avatar>
            <div class="pa-1 text-container">
                <span class="text">{{ answerItem.displayName }}</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator';
import ShoppingGuideAnswer from './ShoppingGuideAnswer.vue';

export default Vue.extend({
    name: 'ShoppingGuideColor',
    mixins: [ShoppingGuideAnswer],
});
</script>

<style scoped lang="scss">
@import '../scss/answerStyles';

.main-container::v-deep {
    .color-item {
        > * {
            cursor: pointer;
        }

        .v-avatar {
            border-width: 2px;
            border-style: solid;
            border-color: transparent;

            .v-image__placeholder {
                height: calc(100% - 4px);
                width: calc(100% - 4px);
                top: 2px;
                left: 2px;
                border-radius: 50%;
            }
        }
    }

    .text-container {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;

        .text {
            font-size: 14px;
            font-weight: 300;
        }
    }
}
</style>
